<template>
    <div>
        <the-dropdown
            v-model="device.type"
            class="mb-0"
            text="Wybierz urządzenie"
            :show-legend="false"
            :options="deviceOptions"
            :selected-option="device.type"
            @change="onDeviceChange"
        />

        <the-input
            class="mb-0"
            type="number"
            step="1"
            invalid-feedback="Osiągnięto maksymalną liczbę urządzeń"
            :min="0"
            :max="max"
            :text="device.qty.toString()"
            @change="updateOptionalQty(+$event.target.value)"
        />

        <the-btn
            class="btn-danger px-1"
            icon="Bin"
            :disabled="isRemoveDisabled"
            @click="removeDevice"
        />
    </div>
</template>

<script>
export default {
    props: {
        additionalDevices: {
            type: Boolean,
            required: true
        },
        device: {
            type: Object,
            required: true
        },
        deviceOptions: {
            type: Array,
            required: true
        },
        qtyLeft: {
            type: Number,
            required: true
        },
        shopDevicesLength: {
            type: Number,
            required: true
        }
    },

    computed: {
        max() {
            if (!this.additionalDevices) {
                return 1
            }

            return this.qtyLeft + this.device.qty
        },

        isRemoveDisabled() {
            // If there's only one device left, disable remove button
            return this.shopDevicesLength === 1
        }
    },

    methods: {
        onDeviceChange(value) {
            this.$emit('update:device', { ...this.device, type: value })
        },

        updateOptionalQty(qty) {
            if (!qty) {
                qty = 0
            }

            this.$emit('update:device', { ...this.device, qty })
        },

        removeDevice() {
            if (this.isRemoveDisabled) {
                return
            }

            this.$emit('remove')
        }
    }
}
</script>